import axios from "axios";

/**
 * Returns true only for 5xx responses where the server received the request
 * and may still be processing it (e.g. proxy/load balancer timeout).
 * Network errors (offline, DNS) and client-side timeouts are excluded
 * because we can't confirm the server received anything.
 */
export function isServerTimeoutError(error: unknown): boolean {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    return !!status && status >= 500;
  }
  return false;
}

/**
 * Returns true for 4xx errors where we can be certain the request was
 * rejected by the server (validation, auth, not found, etc.).
 * Used to distinguish "definitely wrong request" from "might still be
 * processing" (5xx, network errors, CORS-stripped 504s).
 */
export function isDefinitiveClientError(error: unknown): boolean {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    return !!status && status >= 400 && status < 500;
  }
  return false;
}
